import React, { useEffect } from "react";
import styles from "./style.scss";
import { useLocation } from "react-router";
import Heading from "components/Common/Heading";
import Button from "components/Common/Button/Text";
import { Tab } from "features/Tab";
import { PersonalBinderList } from "./Components/PersonalBinderList";
import { NikkeiBinderList } from "./Components/NikkeiBinderList";
import { useIpAuthFlg } from "hooks/useIpAuthFlg";
import { useBinderAction } from "../Common/BinderActionModal/hook";
import { useDispatch } from "react-redux";
import { setSeletedCorpItems } from "modules/binders/item/actions";
import {
  setIsSearch,
  setNikkeiKeyword,
  setNikkeiSearchedKeyword,
  setPersonalKeyword,
  setPersonalSearchedKeyword
} from "modules/binders/list/actions";
import { trackAction } from "utils/helper/analytics";

const tabItems = [
  {
    text: "マイコレクション",
    pathname: "/binder/personal"
  },
  {
    text: "日経コレクション",
    pathname: "/binder/public"
  }
];

export const LAZY_LOAD_LIMIT = {
  card: 6,
  list: 20
};

export const BinderList: React.FunctionComponent = () => {
  const { setBinderActionModal } = useBinderAction();
  const ipAuthFlg = useIpAuthFlg();
  const dispatch = useDispatch();
  const location = useLocation();

  // コレクション一覧から別ページへ遷移したときはキーワード絞り込みをクリアする
  useEffect(() => {
    return () => {
      dispatch(setPersonalKeyword(""));
      dispatch(setPersonalSearchedKeyword(""));
      dispatch(setNikkeiKeyword(""));
      dispatch(setNikkeiSearchedKeyword(""));
      dispatch(setIsSearch(false));
    };
  }, [dispatch]);

  return (
    <div className={styles.component} data-testid="BinderPage-List">
      <div className={styles.title}>
        <Heading level="2">コレクション一覧</Heading>
        <div className={styles.buttonWrapper}>
          {!ipAuthFlg && (
            <AddBinderButton
              openModal={() => {
                setBinderActionModal({ type: "new" });
                dispatch(setSeletedCorpItems([]));
              }}
            />
          )}
        </div>
      </div>
      <Tab
        items={tabItems.filter(
          item => !ipAuthFlg || item.pathname === "/binder/public"
        )}
        borderColor="primary"
      />
      {tabItems[0].pathname === location.pathname && <PersonalBinderList />}
      {tabItems[1].pathname === location.pathname && <NikkeiBinderList />}
    </div>
  );
};

interface AddBinderButtonProp {
  openModal: () => void;
}

const AddBinderButton: React.FunctionComponent<AddBinderButtonProp> = props => (
  <div className={styles.new}>
    <Button
      className={styles.btn}
      onClick={() => {
        trackAction("myCollectionCreate");
        props.openModal();
      }}
      data-testid="BinderPage-List-addBinderButton"
    >
      新規コレクション作成
    </Button>
  </div>
);
